import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, Snackbar } from '@mui/material';
import React from 'react';
const SnackbarContext = React.createContext(undefined);
function SnackbarContextProvider({ children, value, }) {
    return _jsx(SnackbarContext.Provider, { value: value, children: children });
}
function useSnackbarState() {
    const [snackbar, setSnackbar] = React.useState(null);
    const handleClose = () => setSnackbar(null);
    const openSnackbar = ({ type, message }) => {
        const newSnackbar = { key: new Date().getTime(), type, message };
        setSnackbar(newSnackbar);
    };
    return { handleClose, openSnackbar, snackbar };
}
function Snackbars({ snackbar, handleClose, }) {
    if (!snackbar) {
        return null;
    }
    return (_jsx(Snackbar, { open: true, autoHideDuration: 3000, onClose: handleClose, anchorOrigin: { vertical: 'bottom', horizontal: 'left' }, children: _jsx(Alert, { onClose: handleClose, severity: snackbar.type, variant: "filled", sx: { width: '100%' }, children: snackbar.message }) }, snackbar.key));
}
export function SnackbarProvider({ children }) {
    const snackbarState = useSnackbarState();
    return (_jsxs(SnackbarContextProvider, { value: snackbarState, children: [children, _jsx(Snackbars, { snackbar: snackbarState.snackbar, handleClose: snackbarState.handleClose })] }));
}
export function useSnackbar() {
    const snackbar = React.useContext(SnackbarContext);
    if (!snackbar) {
        throw new Error(`Missing SnackbarProvider`);
    }
    return snackbar;
}
